import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
const Project = ({ projectData, setCurrentSelectedProjectId, active }) => {
  const { t } = useTranslation();
  return (
    <div
      onClick={() => {
        setCurrentSelectedProjectId(projectData.id);
      }}
      style={{ backgroundColor: active ? '#1D1D1D' : '#C4C4C4' }}
      className="group relative shadow flex flex-col w-full backdrop-blur-sm rounded-lg cursor-pointer duration-300 ease-in"
    >
      <div className="absolute left-[-18px] top-1/2 -translate-y-1/2 bg-[#1D1D1D] w-[10px] rounded-md h-[3px]"></div>
      <div className="w-full overflow-hidden min-h-[70px] p-2 items-center justify-center flex gap-4">
        <img
          src={projectData.img}
          className="object-cover object-center w-[60px] group h-full rounded-md"
          alt=""
        />
        <div className="flex-1 flex-col flex gap-2">
          <span
            style={{ color: active ? '#FFF' : '#1D1D1D' }}
            className="font-medium group-hover:text-xl"
          >
            {projectData.title}
          </span>
          <span
            style={{ color: active ? '#B8B8B8' : '#1D1D1D' }}
            className="text-sm group-hover:hidden block text-[#c8c8c8] text-clamp"
          >
           {t(projectData.description)}
          </span>
        </div>
      </div>
    </div>
  );
};

Project.propTypes = {
  projectData: PropTypes.shape({
    id: PropTypes.number.isRequired, // 'id' zorunlu bir sayı olmalı
    title: PropTypes.string,
    description: PropTypes.string,
    img: PropTypes.string,
  }).isRequired,
  setCurrentSelectedProjectId: PropTypes.func.isRequired,
  active: PropTypes.bool,
};

export default Project;